import React, { FC } from 'react'

import { SharingStory } from 'components/Story/containers/SharingStory'

import { FeedItem } from './FeedItem'
import { useStoryShareModal } from 'components/Story/common/StoryShareModel'

import { ProjectFeedProps } from './ProjectFeed.props'
import { TStory } from '../../../../components/Story'

const ProjectFeed: FC<ProjectFeedProps> = ({ feed, ...props }) => {

  const [modal, handleModal] = useStoryShareModal<TStory>(
    (data, node) => <SharingStory story={data}>{node}</SharingStory>
  )

  return (
    <>
      {
        feed.map(story => (
          <FeedItem
            key={story.id}
            story={story}
            handleModal={handleModal(story)}
            {...props}
          />
        ))
      }
      {
        modal
      }
    </>
  )
}

export default ProjectFeed
